import { useState } from 'react';

import { downloadCollatedReport } from '@utils/collatedReport';

export const useCollatedReportDownload = (requisitionId: string) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const onDownload = async () => {
    if (isDownloading) return;

    setIsDownloading(true);
    try {
      await downloadCollatedReport(requisitionId);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, onDownload };
};
